import {call, put, takeLatest } from 'redux-saga/effects';
import { request } from '../../../helpers/request';
import { API } from './constants';
import { adminDashboardActions as actions } from '.';
import { AdminDashboardAction, Response } from './types';

export function* fetchDashboardSessionsGenerator({ payload }: AdminDashboardAction) {
  const { productId } = payload;
  if (!productId ) return;

  try {
    const payloadBase = { productId };
    const response: Response = yield call(request, API.GET_DASHBOARD_SESSIONS, payloadBase, true);

    if(response.success) {
      yield put(actions.fetchDashboardSessionsSucceeded(response.data));
    } else {
      yield put(actions.fetchDashboardSessionsFailed({ message: response.message || 'Failed to load analytics.' }));
    }
  } catch (err: any) {
    yield put(actions.fetchDashboardSessionsFailed({ message: err?.message || 'Failed to load analytics.' }));
  }
}

export function* adminDashboardSaga() {
  yield takeLatest(actions.fetchDashboardSessionsRequested.type, fetchDashboardSessionsGenerator);
}

export default adminDashboardSaga;

